import Permissions from './_permissions'

export const auditLogPermissionNames = [
  'AuditlogView',
  'AuditlogDeveloperView',
  'AuditlogGameMasterView',
  'AuditlogContentScripterView',
  'AuditlogCommunityCoordinatorView',
  'AuditlogAdministratorView',
  'AuditlogArtistView',
  'AuditlogModeratorView',
  'AuditlogMapperView',
  'AuditlogMapApprenticeView',
  'AuditlogTradeModeratorView',
  'AuditlogChiefExecutiveOfficerView',
  'AuditlogSpawnEditorView',
  'AuditlogTesterView',
  'AuditlogCSApprenticeView',
  'AuditlogCCApprenticeView',
  'AuditlogArtistApprenticeView',
  'AuditlogModApprenticeView',
  'AuditlogTModApprenticeView',
  'AuditlogTesterApprenticeView',
  'AuditlogStoryWriterView',
  'AuditlogPvpCoordinatorView',
  'AuditlogNewsWriterView'
]

const auditLogActionMap = {
  ModTools: [
    {permission: 'MaintenanceToggle', value: 'MaintenanceMode'}
  ],
  AccountBasics: [
    {permission: 'ApprovedDevicesDelete'}
  ],
  AccountInvestigation: [
    {permission: 'UserInfractionDelete'},
    {permission: 'UserNotesEdit', value: 'UserNoteEdit'}
  ],
  AccountEditing: [
    {permission: 'PermissionChange', permissionCategory: 'ModTools', value: 'ChangeRole', label: 'Role Change', icon: 'fa fa-id-badge'},
    {permission: 'UserNameChange'},
    {permission: 'UserEmailChange'},
    {permission: 'UserMoneyChange'},
    {permission: 'UserCoinChange'},
    {permission: 'UserGuildRoleChange'},
    {permission: 'UserGuildNameChange'},
    {permission: 'UserMembershipExtend'},
    {permission: 'UserServerTransfer'},
    {permission: 'UserReset'},
    {permission: 'UserUnmerge'},
    {permission: 'UserStaffRewardsEdit'}
  ],
  BanTools: [
    {permission: 'UserBan'},
    {permission: 'UserBanMac'},
    {permission: 'MassbanUsers'},
    {permission: 'MassbanEMails'}
  ],
  AccountSnapshots: [
    {permission: 'SnapshotCreate'},
    {permission: 'SnapshotRestore'},
    {permission: 'SnapshotRestoreOwnTest'}
  ],
  TradesInGameMails: [
    {permission: 'TradelogsRevert', value: 'TradeRevert'},
    {permission: 'UserMailsDelete'},
    {permission: 'UserMailsDelete', value: 'UserMailsItemDelete', label: 'In-Game Mails Item Delete'},
    {permission: 'UserMailsRestore'},
    {permission: 'UserMailsRestoreItem'}
  ],
  ItemsInventory: [
    {permission: 'InventoryAddItem'},
    {permission: 'InventoryEditItem'},
    {permission: 'InventoryRemoveItem'},
    {permission: 'MoveClothesToInventory'}
  ],
  Variables: [
    {permission: 'VariablesEdit'},
    {permission: 'VariablesEditDays'},
    {permission: 'VariablesDelete'},
    {permission: 'GlobalVarsDelete'}
  ],
  ModerationTools: [
    {permission: 'ModerationMode', permissionCategory: 'AuditLog', value: 'WarnedUsers', label: 'Warned Users', icon: 'fa fa-exclamation-triangle'},
    {permission: 'WatchlistAdd'},
    {permission: 'WatchlistAdd', value: 'WatchlistUpdate', label: 'Watchlist Update'},
    {permission: 'WatchlistDelete'}
  ],
  PokemonModeration: [
    {permission: 'PokemonRecover'},
    {permission: 'PokemonDelete'},
    {permission: 'PokemonOwnerTransfer'},
    {permission: 'PokemonServerTransfer'},
    {permission: 'PokemonHeldItemToInventory'},
    {permission: 'PokemonDelevel'},
    {permission: 'PokemonAdd'}
  ],
  PokemonEditing: [
    {permission: 'PokemonEditAbility'},
    {permission: 'PokemonEditNature'},
    {permission: 'PokemonEditOT'},
    {permission: 'PokemonEditTradeLock', value: 'PokemonEditTradelock'},
    {permission: 'PokemonEditIVS'},
    {permission: 'PokemonEditForm'}
  ],
  PlayerVersusPlayer: [
    {permission: 'PVPlogView'},
    {permission: 'UserRatingChange'},
    {permission: 'UserRatingChange', value: 'UserRandomRatingChange', label: 'Random PvP Rating Edit'},
    {permission: 'PvpBanlistEdit', value: 'PvpBanlistAdd', label: 'PvP Banlist Add'},
    {permission: 'PvpBanlistEdit', value: 'PvpBanlistEdit', label: 'PvP Banlist Edit'},
    {permission: 'PvpBanlistEdit', value: 'PvpBanlistDelete', label: 'PvP Banlist Delete'},
    {permission: 'PvpRandomSetsView', value: 'RandomBattleSetView', label: 'PvP Random Sets View'},
    {permission: 'PvpRandomSetsEdit', value: 'RandomBattleRulesSave', label: 'PvP Random Battle Rules Save'},
    {permission: 'PvpRandomSetsEdit', value: 'RandomBattleRulesApply', label: 'PvP Random Battle Rules Apply'},
    {permission: 'PvpRandomSetsEdit', value: 'RandomBattleSetAdd', label: 'PvP Random Sets Add'},
    {permission: 'PvpRandomSetsEdit', value: 'RandomBattleSetEdit', label: 'PvP Random Sets Edit'},
    {permission: 'PvpRandomSetsEdit', value: 'RandomBattleSetDelete', label: 'PvP Random Sets Delete'},
    {permission: 'PvpRandomSetsEdit', value: 'RandomTeamsReload', label: 'PvP Random Teams Reload'}
  ],
  News: [
    {permission: 'NewsCreate'},
    {permission: 'NewsEdit'},
    {permission: 'NewsDelete'},
    {permission: 'IngameNewsEdit'},
    {permission: 'IngameNewsEdit', value: 'InfoTextEdit', label: 'Info Text Edit'}
  ],
  DeveloperTools: [
    {permission: 'ForceRestart'},
    {permission: 'ToolsReloadData'}
  ]
}

function findPermission (category, permissionName) {
  if (!Permissions[category] || !Permissions[category].Permissions) {
    return null
  }
  return Permissions[category].Permissions[permissionName] || null
}

export function buildAuditLogActionGroups (canViewPermission = () => true) {
  const groups = []
  Object.keys(Permissions).forEach(category => {
    const definitions = auditLogActionMap[category] || []
    if (definitions.length === 0) {
      return
    }
    const options = []
    definitions.forEach(definition => {
      if (!definition.permission || !canViewPermission(definition.permission)) {
        return
      }
      const permissionCategory = definition.permissionCategory || category
      const permission = findPermission(permissionCategory, definition.permission)
      if (definition.permission && !permission) {
        return
      }
      options.push({
        value: definition.value || definition.permission,
        label: definition.label || permission.Name,
        icon: definition.icon || (permission && permission.icon ? permission.icon : 'fa fa-pencil')
      })
    })
    if (options.length > 0) {
      groups.push({
        label: Permissions[category].Name,
        options
      })
    }
  })
  return groups
}
